import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { AccountItem } from '../../components/account-item'
import { AddAccount } from '../../components/add-account'
import { PlaidButton } from '../../components/plaid-button'
import { AddAccountPaths } from '../../config/routes'
import { useUser } from '../../contexts/user/user-context'
import { useAccounts } from '../../hooks/use-accounts'
import { usePixel } from '../../hooks/use-pixel'
import { MasaAccount, MasaConnectionProvider } from '../../models'

export function AddBankAccount() {
    const history = useHistory()
    usePixel({ page: 'Add-bank-account' })
    const [plaidLoading, setPlaidLoading] = useState(false)
    const {
        getTypeAccounts,
        accounts,
        userHasAnAccount,
        loading: loadingAccounts,
    } = useAccounts({
        type: MasaConnectionProvider.PLAID,
    })

    const { userProfile }: any = useUser()

    useEffect(() => {
        const getUserProfile = userProfile?.getUserProfile ?? {}
        if (getUserProfile?.country?.abbreviation === 'USA') {
            history.push(AddAccountPaths.ADD_COINBASE_ACCOUNT)
        }
    }, [userProfile, history])

    const loading = useMemo(
        () => loadingAccounts || plaidLoading,
        [loadingAccounts, plaidLoading],
    )

    const handleRenderAccount = (account: MasaAccount, idx: number) => (
        <AccountItem
            className='rounded-md'
            name={account?.name ?? ''}
            lastUpdatedOne={new Date((account as any).lastUpdated)}
            balanceInfo={{
                current: account?.amount?.value ?? 0,
                isoCurrencyCode: account?.amount?.currency ?? '',
            }}
            key={`account-${idx}`}
        />
    )

    const refetchAccounts = () => {
        getTypeAccounts()
    }

    return (
        <AddAccount
            providerName='Plaid'
            providerButton={
                <PlaidButton
                    saveAccounts={getTypeAccounts}
                    firstAccount={!userHasAnAccount}
                    onLoading={setPlaidLoading}
                    onFinish={refetchAccounts}
                />
            }
            renderAccounts={handleRenderAccount}
            accounts={accounts}
            loading={loading}
            loadingAccounts={loadingAccounts}
        />
    )
}
